import { compact, flattenDeep, forEach, groupBy, head, join, map, round, sum } from 'lodash-es';
import moment from 'moment';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { analytics } from '../../services/analytics';
import DeliveryStatus from '../../components/deliveryStatus';
import GoogleMaps from '../../components/googleMaps';
import ScheduledDeliveryDate from '../../components/scheduled-delivery-date';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import template from './shipmentView.vue';

import qs from 'qs';
import switchBillingToService from '../../shared/switchBillingToService';
@Component({
    mixins: [template],
    components: {
        UnisProductModal,
        GoogleMaps,
        DeliveryStatus,
        ScheduledDeliveryDate,
    },
})
export default class ShipmentView extends Vue {
    proId: any = '';
    orderId: any = '';
    showErrTip: boolean = false;
    errorText: String = '';
    tabTit: any = ['Overview', 'Activity', 'Products', 'Documents', 'Quote'];
    tabArr: any = [true, false, false, false, false];
    showActivity: any = {};
    palletInfos: any = [
        'Pallets: Standard (40" x 48")',
        'Pallets: (60" x 48")',
        'Pallets: (48" x 48")',
        'Pallets: (enter dimensions)',
    ];
    setmarkers: Array<any> = [
        {
            lat: 33.966324,
            lng: -118.242134,
            state: 'finish',
        },
    ];
    setCenter: any = {
        lat: 33.966324,
        lng: -118.242134,
    };
    trackedShipment: any = {};
    deliveryStages: any = 3;
    overView: any = {};
    pickupAdditionalServices: Boolean = false;
    deliveryAdditionalServices: Boolean = false;
    isShowWalkthrough: Boolean = false;
    billToId: any = '';
    invoice: any = {};
    invoiceList: any = [];
    activity: any = [];
    documents: any = [];
    quoteDetail: any = [];
    quoteTotal: number = 0;
    products: any = {};
    from: any = '';
    resChoosingUNIS: any = 'resChoosingUNIS';
    isBusinessType: Boolean = false;
    ReturnToList: any = 'Return to invoice List';

    created() {
        this.orderId = this.$route.params.orderId;
        this.from = this.$route.params.from;
        this.init();
        if (this.from == '1') {
            this.ReturnToList = 'Return to shipments List';
            return;
        }
        if (this.from == '3') {
            this.ReturnToList = 'Return to tasks List';
            return;
        }
        if (this.from == '4') {
            this.ReturnToList = 'Return to quotes List';
            return;
        }
        if (this.from == '5') {
            this.ReturnToList = 'Return to dashboard page';
            return;
        }
        this.ReturnToList = 'Return to invoice List';
    }

    async mounted() {
        await switchBillingToService.post().then(
            (res: any) => {
                if (res.data.billing) {
                    this.billToId = res.data.billing.location_id;
                }
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    async init() {
        this.overView = await this.getOverview();
        this.getInvoiceList();
        forEach(this.overView.manifest, item => {
            if (item.tms_manifest_code && item.tms_manifest_code == 'PL') {
                this.pickupAdditionalServices = true;
            } else if (item.tms_manifest_code && item.tms_manifest_code == 'DL') {
                this.deliveryAdditionalServices = true;
            }
        });
        this.proId = this.overView.order_pro;
        if (this.overView.ar_id) {
            this.getInvoice(this.overView.ar_id);
        }
        this.getTrackShipment();
    }

    getInvoiceList() {
        tmsServiceBackend.get(`/tms/${this.orderId}/invoices`).then(
            (res: any) => {
                if (res.data.data) {
                    this.invoiceList = res.data.data;
                }
            },
            (err: any) => {}
        );
    }

    tab(index: any) {
        const tabNames = ['overview', 'activity', 'products', 'documents', 'quote'];
        analytics.trackTabSwitch({ tabName: tabNames[index] || 'shipment_view' });
        this.tabArr = [false, false, false, false, false];
        this.tabArr[index] = true;
        if (index == 3) {
            if (this.documents.length > 0) {
                return;
            }
        } else if (index == 4) {
            if (this.quoteDetail.length > 0) {
                return;
            }
            this.getQuote();
        } else if (index == 2) {
            if (this.products.products) {
                return;
            }
            this.getProducts();
        }
    }

    getOverview() {
        return new Promise((resolve, reject) => {
            tmsServiceBackend.post(`order/getOrderDetail?order_id=${this.orderId}`).then(
                (res: any) => {
                    if (res.data.data) {
                        resolve(res.data.data);
                    } else {
                        resolve({});
                    }
                },
                (err: any) => {
                    this.showErrorFun(err.response.data.statusText);
                    reject({});
                }
            );
        });
    }

    getTrackShipment() {
        tmsServiceBackend.get(`/cpv2/tracking/track?order_id=${this.orderId}`).then(
            (res: any) => {
                if (res.data.status == 0) {
                    this.showErrorFun(res.data.message);
                    return;
                }
                let data = res.data.data;
                this.trackedShipment = head(data);
                this.fillTrackedShipment();
                this.setmarkers = [];
                if (
                    this.trackedShipment &&
                    this.trackedShipment.pickup_lat &&
                    this.trackedShipment.pickup_lng
                ) {
                    this.setmarkers.push({
                        total_Miles: this.trackedShipment['total_Miles'],
                        locationState: this.trackedShipment['pickup_state'],
                        city: this.trackedShipment['pickup_city'],
                        lat: parseFloat(this.trackedShipment.pickup_lat),
                        lng: parseFloat(this.trackedShipment.pickup_lng),
                        state: 'continuous',
                    });
                }
                if (
                    this.trackedShipment &&
                    this.trackedShipment.delivery_lat &&
                    this.trackedShipment.delivery_lng
                ) {
                    this.setmarkers.push({
                        total_Miles: this.trackedShipment['total_Miles'],
                        locationState: this.trackedShipment['delivery_state'],
                        city: this.trackedShipment['delivery_city'],
                        lat: parseFloat(this.trackedShipment.delivery_lat),
                        lng: parseFloat(this.trackedShipment.delivery_lng),
                        state: 'finish',
                    });
                }
                if (
                    this.trackedShipment &&
                    this.trackedShipment.delivery_lat &&
                    this.trackedShipment.delivery_lng
                ) {
                    this.setCenter = {
                        lat: parseFloat(this.trackedShipment.delivery_lat),
                        lng: parseFloat(this.trackedShipment.delivery_lng),
                    };
                }

                this.documents = flattenDeep(map(res.data.data, 'pictures'));
                forEach(this.documents, (item: any) => {
                    if (item.file_category_name == 'CONF_RATE') this.$set(item, 'fileName', 'LOA');
                    if (item.file_category_name == 'INSP_CERT') this.$set(item, 'fileName', 'W&I');
                });
            },
            (err: any) => {
                this.showErrorFun(err.response.data.statusText);
            }
        );
    }

    private fillTrackedShipment() {
        if (this.trackedShipment.d_date2) {
            let time = moment(this.trackedShipment.d_date2).format('LLLL');
            let timeArray = time.split(',');
            this.trackedShipment['scheduledDelivery'] = join(timeArray.slice(0, 2), ',');
        }
        forEach(this.trackedShipment.histories, history => {
            let time = moment(history.tms_order_log_created_date).format('LLLL');
            let year = moment(history.tms_order_log_created_date).format('YYYY');
            let timeArray = time.split(',');
            history['groupName'] = join(timeArray.slice(0, 2), ',') + ',' + year;
            let cDateYear = history.c_date ? moment(history.c_date).format('MM/DD/YYYY') : '';
            let cDateTime = history.c_date ? moment(history.c_date).format('HH:mm A') : '';
            history['cDateYear'] = cDateYear;
            history['cDateTime'] = cDateTime;
        });
        this.activity = groupBy(this.trackedShipment.histories, 'groupName');

        forEach(this.activity, (activity, key) => {
            let cDateYears = compact(map(activity, 'c_date'));
            let tmsOrderLogTexts = compact(map(activity, 'tms_order_log_text'));
            if (cDateYears.length > 0 && tmsOrderLogTexts.length > 0) {
                this.showActivity[key] = true;
            }
        });
        this.getProgressImage(this.trackedShipment.stage, this.trackedShipment.status);
    }

    private getProgressImage(shipmentStage: any, shipmentStatus: any) {
        if (shipmentStatus == 4 && shipmentStage == 5) {
            // Invoiced
            this.deliveryStages = 5;
        } else if (shipmentStage == 5 && shipmentStatus > 0) {
            // Delivered
            this.deliveryStages = 4;
        } else if (shipmentStage == 4 && shipmentStatus > 0) {
            // Out for Delivery
            this.deliveryStages = 3;
        } else if (shipmentStage == 1 || shipmentStage == 2 || shipmentStage == 3) {
            // Picked U
            this.deliveryStages = 2;
        } else if (shipmentStage == 0 && shipmentStatus > 1) {
            // In Process
            this.deliveryStages = 2;
        } else if (shipmentStage == 0 && shipmentStatus == 1) {
            // Order created
            this.deliveryStages = 1;
        }
        this.$forceUpdate();
    }

    getProducts() {
        let param: any = {
            order_id: this.orderId,
        };
        tmsServiceBackend.post(`/cpv2/shipment/getProducts`, qs.stringify(param)).then(
            (res: any) => {
                this.products = res.data.data;
            },
            (err: any) => {
                this.showErrorFun(err.response.data.message);
            }
        );
    }

    getInvoice(arId: any) {
        tmsServiceBackend.get(`/tms/invoices/${arId}/detail?billto_id=${this.billToId}`).then(
            (res: any) => {
                this.invoice = res.data.data;
            },
            (err: any) => {
                this.showErrorFun(err.response.data.message);
            }
        );
    }

    getQuote() {
        tmsServiceBackend.get(`quote/getQuoteDetail?order_id=${this.orderId}`).then(
            (res: any) => {
                this.quoteDetail = res.data;
                let itemAmount: any = [];
                forEach(this.quoteDetail, item => {
                    itemAmount.push(Number(item.amount));
                });
                this.quoteTotal = round(sum(itemAmount), 2);
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    goShimentList() {
        if (this.from == '1') {
            this.$router.replace({
                name: 'shipment',
            });
            return;
        }
        if (this.from == '3') {
            this.$router.replace({
                name: 'Tasks',
            });
            return;
        }
        if (this.from == '4') {
            this.$router.replace({
                name: 'QuoteList',
            });
            return;
        }
        if (this.from == '5') {
            this.$router.replace({
                name: 'Home',
            });
            return;
        }
        if (this.from == '6') {
            history.back();
            return;
        }
        history.back();
    }

    viewDocument(url: string) {
        window.open(`${url}`);
    }

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }

    ishideMapRoute: any = false;
    funHideMapRoute() {
        this.ishideMapRoute = !this.ishideMapRoute;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/shipmentView/index.ts